import { boardDarkModeStore } from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class BoardDarkModeMixin extends Vue {
  isBoardDarkMode = false;
  private readonly boardDarkModeStorageHandler = (event: StorageEvent) => {
    if (event.key !== boardDarkModeStore.key) {
      return;
    }

    this.isBoardDarkMode = boardDarkModeStore.get() ?? false;
  };

  mounted() {
    this.isBoardDarkMode = boardDarkModeStore.get() ?? false;
    window.addEventListener("storage", this.boardDarkModeStorageHandler);
  }

  beforeDestroy() {
    window.removeEventListener("storage", this.boardDarkModeStorageHandler);
  }

  @Watch("isBoardDarkMode")
  onBoardDarkModeChanged(value: boolean) {
    boardDarkModeStore.set(value);
  }
}
